/* tslint:disable */
/* eslint-disable */
/**
 * BROStar API
 * Simplify the data management of the BRO
 *
 * The version of the OpenAPI document: v1
 * Contact: servicedesk@nelen-schuurmans.nl
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { FRD } from "./FRD";
import { FRDFromJSON, FRDFromJSONTyped, FRDToJSON, FRDToJSONTyped } from "./FRD";

/**
 *
 * @export
 * @interface ApiFrdFrdsList200Response
 */
export interface ApiFrdFrdsList200Response {
  /**
   *
   * @type {number}
   * @memberof ApiFrdFrdsList200Response
   */
  count: number;
  /**
   *
   * @type {string}
   * @memberof ApiFrdFrdsList200Response
   */
  next?: string | null;
  /**
   *
   * @type {string}
   * @memberof ApiFrdFrdsList200Response
   */
  previous?: string | null;
  /**
   *
   * @type {Array<FRD>}
   * @memberof ApiFrdFrdsList200Response
   */
  results: Array<FRD>;
}

/**
 * Check if a given object implements the ApiFrdFrdsList200Response interface.
 */
export function instanceOfApiFrdFrdsList200Response(
  value: object
): value is ApiFrdFrdsList200Response {
  if (!("count" in value) || value["count"] === undefined) return false;
  if (!("results" in value) || value["results"] === undefined) return false;
  return true;
}

export function ApiFrdFrdsList200ResponseFromJSON(json: any): ApiFrdFrdsList200Response {
  return ApiFrdFrdsList200ResponseFromJSONTyped(json, false);
}

export function ApiFrdFrdsList200ResponseFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): ApiFrdFrdsList200Response {
  if (json == null) {
    return json;
  }
  return {
    count: json["count"],
    next: json["next"] === undefined ? undefined : json["next"] === null ? null : json["next"],
    previous:
      json["previous"] === undefined
        ? undefined
        : json["previous"] === null
        ? null
        : json["previous"],
    results: (json["results"] as Array<any>).map(FRDFromJSON),
  };
}

export function ApiFrdFrdsList200ResponseToJSON(json: any): ApiFrdFrdsList200Response {
  return ApiFrdFrdsList200ResponseToJSONTyped(json, false);
}

export function ApiFrdFrdsList200ResponseToJSONTyped(
  value?: ApiFrdFrdsList200Response | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    count: value["count"],
    next: value["next"],
    previous: value["previous"],
    results: (value["results"] as Array<any>).map(FRDToJSON),
  };
}
